import React from 'react';
import './BarcodeNotFound.css';

export interface BarcodeNotFoundProps {
  barcode: string;
  onClear: () => void;
  onManualEntry: () => void;
  className?: string;
}

const BarcodeNotFound: React.FC<BarcodeNotFoundProps> = ({
  barcode,
  onClear,
  onManualEntry,
  className = ""
}) => {
  return (
    <div className={`barcode-not-found ${className}`}>
      <div className="barcode-not-found__content">
        <div className="barcode-not-found__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
        </div>
        
        <h3 className="barcode-not-found__title">
          Product Not Found
        </h3>
        
        <p className="barcode-not-found__message">
          No product found for this barcode in your Grocy system or external database.
        </p>
        
        <div className="barcode-not-found__barcode">
          Scanned: {barcode}
        </div>
        
        <div className="barcode-not-found__actions">
          <button
            onClick={onClear}
            className="barcode-not-found__clear-button"
          >
            Scan Another Item
          </button>
          <button
            onClick={onManualEntry}
            className="barcode-not-found__manual-button"
          >
            Manual Entry
          </button>
        </div>
      </div>
    </div>
  );
};

export default BarcodeNotFound;
